import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=595df3f4&scoped=true"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=595df3f4&prod&lang=scss&scoped=true"
import style1 from "./TableOfContents.vue?vue&type=style&index=1&id=595df3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595df3f4",
  null
  
)

export default component.exports